import { createFileRoute, redirect } from "@tanstack/react-router";

// Premium is switched off for now: send visitors to the home page.
export const Route = createFileRoute("/_app/premium")({
  loader: () => {
    throw redirect({ to: "/", statusCode: 302 });
  },
});
